import { useAuth } from '../contexts/AuthContext';
import { LogoutButton } from './NavButtons';

function AppHeader() {
  const { signOut, user } = useAuth();
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'دانش آموز';

  return (
    <header className="w-11/12 mx-auto py-4">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center gap-1 bg-[#F8F8F8] rounded-[10px] px-3 py-1">
          <div className="w-[30px] h-[30px] overflow-hidden">
            <img className="object-cover w-full" src={user?.avatar || '/images/user-vector.png'} alt="" />
          </div>

          <div>
            <p className="text-[11px]">
              {fullName} - <span className="font-light">دانش آموز</span>
            </p>
          </div>
        </div>

        <LogoutButton onClick={signOut} />
      </div>
    </header>
  );
}

export default AppHeader;
